import moment from "moment";
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";

import { getRequest } from '../../../../config';

export default function Analyser({ company, getCompany, setTab, setCompanyDashboardTab, permissionLevel }) {

    let user = useSelector(state => state.user);

    // State for AI reports
    let [aiReports, setAiReports] = useState([]);
    let [loadingReports, setLoadingReports] = useState(false);

    // Fetch AI reports from company data
    useEffect(() => {
        const fetchAiReports = async () => {
            if (company?._id && !loadingReports) {
                setLoadingReports(true);
                try {
                    const response = await getRequest(`/company/${company._id}/reports`);
                    if (response['code'] == 200 && response['body']?.['reports']) {
                        setAiReports(response['body']['reports']['aiReports'] || []);
                    }
                } catch (e) {
                    console.error('Failed to fetch AI reports:', e);
                } finally {
                    setLoadingReports(false);
                }
            }
        };
        fetchAiReports();
    }, [company?._id]);

    // Helper function to sanitize reportLabel for URL usage
    const sanitizeReportLabel = (label) => {
        if (!label) return '';
        return label
            .toLowerCase()
            .replace(/\s+/g, '-')  // Replace spaces with dashes
            .replace(/[^a-z0-9-]/g, '')  // Remove special characters
            .replace(/-+/g, '-')  // Replace multiple dashes with single dash
            .replace(/^-|-$/g, '');  // Remove leading/trailing dashes
    };

    const handleReportRedirect = (report) => {
        // CHECK EXPANSION PACK PERMISSIONS LEVEL OF ADVISORS/INVESTORS
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD')) {
            return;
        };

        // Use sanitized reportLabel as the tab identifier, with -analyser suffix
        // Fallback to _id if reportLabel is not available
        const tabIdentifier = report['reportLabel']
            ? sanitizeReportLabel(report['reportLabel'])
            : report['_id'];
        setTab(`${tabIdentifier}-analyser`);
        setCompanyDashboardTab('Dashboard');
    };

    const reportCard = (report) => {
        let creator;
        if (report?.['createdBy']) creator = report?.['createdBy'];
        return <div className={`bo7 w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem mx1rem my1-5rem pr bsbb`}>
            <div className='right-info-hyper-icon' style={{ top: '-20px', right: '-20px' }}>
                <div className='cp info-icon pr ml0-5rem'>
                    <img className="" src={require(`../../../../../images/three-dot-icon.png`)} alt="three-dot-icon" />
                </div>
            </div>
            <Link className="ttc fs1rem fw500 c15 lh2 zi1 w100">
                <Link className="cp w100 h100" style={{ minHeight: '130px' }}>
                    <div className='w100 df aic'>
                        <i className='icon-diligenstia mr1rem'><img className="br5px w50px" src={require(`../../../../../images/checklist-logo.png`)} alt="" /></i>
                        <div class='df fdc mr1rem'>
                            <p className="w100 fs0-75rem fw300 c12 mb0-5rem">Diligentsia AI Analyser</p>
                            {report?.['htmlReport']
                                ? <Link to={permissionLevel != 'DASHBOARD' && `#${report['reportLabel'] ? sanitizeReportLabel(report['reportLabel']) : report['_id']}-analyser`} onClick={() => handleReportRedirect(report)} className="w100 fs1rem c15">{report['reportLabel'] || report['name']} Report</Link>
                                : <span className="w100 fs1rem c15">{report['reportLabel'] || report['name']} Report</span>
                            }
                        </div>
                    </div>
                    <div className="w100 df jcsb mt3rem px1rem">
                        {report?.['htmlReport'] && creator
                            ? <>
                                {company['subscription'] == 'Free'
                                    ? <div class='df fdc mt1rem'>
                                        <p class='w100 fs0-75rem fw300'>Executive Summary only.</p>
                                        <p class='w100 fs0-75rem fw300'>To <span class='c7 fw500'>UNLOCK</span> upgrade to PRO/LITE</p>
                                    </div>
                                    : <div class='df jcsb'>
                                        <span data-tooltip={`${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`} className="shadow w40px h40px bg16 bw3px bss bo19 df jcc aic br100 c1">
                                            {creator?.profile
                                                ? <img src={creator.profile} className="new-shadow w30px h30px df jcc aic br100 bg16 c1" data-tooltip={`${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`} />
                                                : <span className='bg16 c15 br50px' data-tooltip={`${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`}>
                                                    {creator?.firstName ? (creator.firstName[0] + (creator.lastName?.[0] || "")) : "?"}
                                                </span>}
                                        </span>
                                        <p class='fs0-75rem c15 ml0-5rem'>{moment(report.createdAt).format('ll')}</p>
                                    </div>
                                }
                                <div class='df fdc'>
                                    <p class={`fs1-5rem tac ${report?.['validation']['accuracyRating'] >= 4 ? 'c34' : report?.['validation']['accuracyRating'] >= 2 ? 'c39' : 'c4'}`}>
                                        {report?.['validation']['accuracyRating'] || 'N/A'}
                                        {report?.['validation']['accuracyRating'] && <span class='fs0-75rem'>/10</span>}
                                    </p>
                                    <p class='fs0-75rem fw400 c15'>Report <br /> Score</p>
                                </div>
                            </>
                            : <div class='df fdc mt1rem'>
                                <p class='w100 fs0-75rem fw300 c12'>No report generated yet</p>
                            </div>
                        }
                    </div>
                </Link>
            </Link>
        </div>
    };

    const dummyReportCard = (subscription) => {
        return <div className={`bo7 w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem mx1rem my1-5rem pr bsbb`}>
            <div className='right-info-hyper-icon' style={{ top: '-20px', right: '-20px' }}>
                <div className='cp info-icon pr ml0-5rem'>
                    <img className="" src={require(`../../../../../images/three-dot-icon.png`)} alt="three-dot-icon" />
                    <div className='overlay-box'><p className='c15'>What is it?</p></div>
                </div>
            </div>
            <Link className="ttc fs1rem fw500 c15 lh2 zi1 w100">
                <Link className="cp w100 h100" style={{ minHeight: '130px' }}>
                    <div className='w100 df aic'>
                        <i className='icon-diligenstia mr1rem'><img className="br5px w50px" src={require(`../../../../../images/checklist-logo.png`)} alt="" /></i>
                        <div class='df fdc mr1rem'>Your AI Report Here</div>
                        {subscription == 'PRO' && <>
                            <i data-tooltip='Edit' className="cp fa fa-edit pl1rem c3" style={{ fontSize: '20px', fontWeight: '400' }} />
                            <i data-tooltip='History' className="cp fa fa-history pl1rem c4" style={{ fontSize: '20px', fontWeight: '400' }} />
                        </>}
                    </div>
                    <div className="w100 df jcsb mt3rem px1rem">
                        <div class='df fdc mt1rem'>
                            {subscription == 'PRO'
                                ? <p class='w100 fs0-75rem fw300'><span class='c7 fw500'>UNLOCK</span> to view full AI report. <br /> Plus generate custom reports</p>
                                : <p class='w100 fs0-75rem fw300'>Upgrade to LITE. <span class='c7 fw500'>UNLOCK</span> full <br /> AI report to see insights</p>
                            }
                        </div>
                        <div class='df fdc'>
                            <p class={`fs1-5rem tac c12`}>0.0</p>
                            <p class='fs0-75rem fw400 c12'>Report <br /> Score</p>
                        </div>
                    </div>

                </Link>
            </Link>
        </div>
    };

    const upgradeCard = (subscription) => {
        return <div className='shadow bg1 tac w100 h200px p1rem br30px'>
            <h4 className="pr" style={{ bottom: '20%' }}><span className="shadow c59 fs1-25rem px1-5rem br10px bw1px bo59 bss ttu" style={{ background: '#E4FFEB' }}>{subscription}</span></h4>
            <div className="subs-btn mt0-5rem">
                <p className="fs1rem fw500 c15 mb0-5rem">Have you thought <br /> about upgrading?</p>
                <Link to={`/billing/${company['_id']}`} className="bg4 bg3-hover fs0-75rem fw600 c1 td250 br30px px3rem py0-5rem cp tac mt0-5rem">Find out more</Link>
            </div>
        </div>
    };

    return (
        <>
            <div className='sectionWrapper py1rem fs0-75rem pr anylist-builder-tab'>
                {/* AI Reports Section */}
                <div className='mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb'>
                    <h3 className="fs1-25rem c15 w100 pl1rem mb2rem">AI Analyser Reports - <span class='fw600 c7 ttu'>{company['subscription']}</span></h3>
                    {(aiReports && aiReports.length > 0) && aiReports.map(item => reportCard(item))}
                    {(!aiReports || aiReports.length === 0) && (
                        <div className='w100 tac py3rem'>
                            <p className='fs1rem c12'>No AI reports available yet</p>
                        </div>
                    )}
                    <div className="research-aid-ai-img">
                        {aiReports && aiReports.length > 0 ? <img className="pa r0 b0" src={require(`../../../../../images/research-aid-ai.png`)} alt="ai-analyser" /> : <img style={{ position: 'absolute', bottom: '0', right: '0' }} src={require(`../../../../../images/analyser.png`)} alt="ai-analyser" />}
                    </div>

                </div>

                {/* Upgrade to Lite */}
                {company['subscription'] == 'Free' &&
                    <div className='mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb'>
                        <h3 className="fs1-25rem c15 w100 pl1rem">AI Analyser Reports - <span class='fw600 c7 ttu'>Lite</span></h3>
                        <div class='w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb'>
                            <div className="grs1-md df fdc aic tac w20 mt2rem">
                                {upgradeCard('Lite')}
                            </div>
                            <div className="df fww w80 coreworkspace-update">
                                {dummyReportCard('Lite')}
                            </div>
                        </div>
                        <div className="research-aid-ai-img">
                            {aiReports && <img className="pa r0 b0" src={require(`../../../../../images/research-aid-ai-lite.png`)} alt="ai-analyser" />}
                        </div>
                    </div>
                }

                {/* Upgrade to PRO */}
                {(company['subscription'] == 'Free' || company['subscription'] == 'Lite') &&
                    <div className='mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb'>
                        <h3 className="fs1-25rem c15 w100 pl1rem">AI Analyser Reports - <span class='fw600 c7 ttu'>PRO</span></h3>
                        <div class='w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb'>
                            <div className="grs1-md df fdc aic tac w20 mt2rem">
                                {upgradeCard('PRO')}
                            </div>
                            <div className="df fww w80 coreworkspace-update">
                                {dummyReportCard('PRO')}
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}
